import type { TBboxStyleAttrs } from '@vlabs/monokit/shared/ui/canvas/bbox-renderer/types';

export const BBOX_STYLES: Record<string, TBboxStyleAttrs> = {
  undefined: {
    base: { stroke: 'rgba(105, 115, 134, 1)', strokeWidth: 2 },
  },
  true: {
    base: { stroke: 'rgba(0, 153, 39, 1)', strokeWidth: 2 },
  },
  false: {
    base: { stroke: 'rgba(204, 10, 0, 1)', strokeWidth: 2 },
  },
};
